<template>
  <div id="app">
    <aggreement v-if="showConsentForm" @submit-consent="handleConsentSubmit"></aggreement>
    <div v-else>
      <!-- 使用Vue Router实现的导航菜单 -->
      <div class="nav">
        <router-link to="/basic" active-class="active" class="nav-link">基本信息</router-link>
        <router-link to="/wenzhen" active-class="active" class="nav-link">问诊</router-link>
        <router-link to="/face" active-class="active" class="nav-link">面诊</router-link>
        <router-link to="/tongue" active-class="active" class="nav-link">舌诊</router-link>
        <router-link to="/voice" active-class="active" class="nav-link">闻诊</router-link>
        <router-link to="/pulse" active-class="active" class="nav-link">脉诊</router-link>
        <router-link to="/userinfo" active-class="active" class="nav-link">个人信息综合</router-link>
        <button class="submit-diagnose-btn" @click="submitToDiagnose">提交进行诊断</button>
      </div>

      <!-- 确保所有路由视图都有正确的事件监听,分别有对应的事件处理方法 -->
      <router-view v-if="$route.path !== '/userinfo'" @submit-wenzhen-view="handleWenzhenViewSubmit"
        @submit-basic-view="handleBasicViewSubmit" @submit-face-view="handleFaceViewSubmit"
        @submit-tongue-view="handleTongueViewSubmit" @submit-voice-view="handleVoiceViewSubmit"
        @submit-pulse-view="handlePulseViewSubmit"></router-view>
      <!-- 个人信息综合页面，传递实时数据,通过 props 将各种数据传递给 UserView 子组件 -->
      <UserView v-if="$route.path === '/userinfo'" :basic-info="userInfo" :wenzhen-info="wenzhenData"
        :wenzhen-audio="wenzhenAudioData" :shezhen-info="shezhenData" :maizhen-info="maizhenData"
        :mianzhen-info="mianzhenData" />
    </div>

    <div id="top"></div>

    <div v-if="isLoading" class="overlay">
      <div class="spinner-wrapper">
        <vue-simple-spinner :size="60" :line-size="5" :line-bg="'#3498db'" :line-fg="'#ffffff'"
          :speed="1.5"></vue-simple-spinner>
        <p class="loading-text">请等候...</p>
      </div>
    </div>
  </div>
</template>

<script>
// 1.组件导入
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import LoadingOverlay from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueSimpleSpinner from 'vue-simple-spinner';
import Aggreement from './views/aggreement.vue';
import UserView from './views/UserView.vue';


// API基础URL

export default {

  name: 'App',
  components: {
    Aggreement,
    LoadingOverlay,
    VueSimpleSpinner,
    UserView
  },
  data() {
    return {
      BaseUrl: process.env.VUE_APP_API_BASE_URL,
      showConsentForm: true,//控制知情同意书的显示
      //用户基本信息
      user: {
        height: '',
        weight: '',
        age: '',
        gender: '',
        phone: '',
        medicalRecordNumber: '',
        recentSymptoms: '',
      },

      pastMedicalHistory: [],//既往病史
      zangfuSelections: [],//脏腑选择
      rhinitisSelections: [],//鼻炎症状选择

      wenzhenViewpGrade: [],//问诊评分
      wenzhenViewpGradeAnswer: [],//问诊答案
      faceViewPhoto: null,
      tongueViewPhoto: null,
      voiceViewAudio: null,
      pulseViewPulse: null,

      // 个人信息综合数据 - 实时更新, 这些数据将通过 props 传递给子组件
      userInfo: {
        height: '',
        weight: '',
        age: '',
        gender: '',
        phone: '',
        medicalRecordNumber: '',
        recentSymptoms: '',
        pastMedicalHistory: ''
      },
      wenzhenData: {
        physique: '',
        zangfu: '',
        rhinitis: '',


        analysisResult: []
      },
      wenzhenAudioData: {
        audioUrl: '',
        duration: '待计算',
        uploadTime: '',
        analysisResult: {
          tone: '',
          strength: '',
          rhythm: '',
          diagnosis: ''
        }
      },
      shezhenData: {
        photoUrl: '',
        uploadTime: '',
        analysisResult: []
      },
      maizhenData: {
        fileUrl: '',
        fileName: '',
        fileType: '',
        uploadTime: '',
        analysisResult: []
      },
      mianzhenData: {
        photoUrl: '',
        uploadTime: '',
        analysisResult: {}
      },
      earViewPhoto: null, // 耳部照片数据
      earAnalysisResult: '', // 耳诊分析结果
      // 存储中医诊断结果
      physique: {
        wenzhenPhysique: [],
        facePhysique: [],
        tonguePhysique: [],
        pulsePhysique: [],
      },
      // 控制加载状态的显示
      isLoading: false,
      // 控制是否全屏
      fullPage: true,


    }
  },
  computed: {
    // 创建计算属性来简化访问嵌套对象的属性
    chinColor() {
      // 安全访问面诊结果
      if (!this.physique.facePhysique || !this.physique.facePhysique.filtered_results) {
        return '正常';
      }
      return this.physique.facePhysique.filtered_results.下巴 || '正常';
    },
    rightCheekColor() {
      if (!this.physique.facePhysique || !this.physique.facePhysique.filtered_results) {
        return '正常';
      }
      return this.physique.facePhysique.filtered_results.右脸颊 || '正常';
    },
    leftCheekColor() {
      if (!this.physique.facePhysique || !this.physique.facePhysique.filtered_results) {
        return '正常';
      }
      return this.physique.facePhysique.filtered_results.左脸颊 || '正常';
    },
    headColor() {
      if (!this.physique.facePhysique || !this.physique.facePhysique.filtered_results) {
        return '正常';
      }
      return this.physique.facePhysique.filtered_results.额头 || '正常';
    },
    noseColor() {
      if (!this.physique.facePhysique || !this.physique.facePhysique.filtered_results) {
        return '正常';
      }
      return this.physique.facePhysique.filtered_results.鼻子 || '正常';
    },
    tonguePhysiqueDescription() {
      // 安全地处理舌诊体质数据
      if (!this.physique.tonguePhysique || !this.physique.tonguePhysique.length) {
        return '待分析';
      }

      const tongueData = this.physique.tonguePhysique[0];

      // 如果是数组，使用 join
      if (Array.isArray(tongueData)) {
        return tongueData.join(", ");
      }

      // 如果是字符串，直接返回
      if (typeof tongueData === 'string') {
        return tongueData;
      }

      // 如果是对象，转换为字符串
      if (typeof tongueData === 'object' && tongueData !== null) {
        try {
          return JSON.stringify(tongueData);
        } catch (e) {
          return '数据格式异常';
        }
      }

      return '待分析';
    },
    pulsePhysique() {
      // 安全地处理脉诊体质数据
      if (!this.physique.pulsePhysique || !this.physique.pulsePhysique.length) {
        return '待分析';
      }

      const pulseData = this.physique.pulsePhysique[0];

      // 如果是数组，使用 join
      if (Array.isArray(pulseData)) {
        return pulseData.join(", ");
      }

      // 如果是字符串，直接返回
      if (typeof pulseData === 'string') {
        return pulseData;
      }

      // 如果是对象，转换为字符串
      if (typeof pulseData === 'object' && pulseData !== null) {
        try {
          return JSON.stringify(pulseData);
        } catch (e) {
          return '数据格式异常';
        }
      }

      return '待分析';
    },
    wenzhenPhysiqueDescription() {
      // 安全地处理问诊体质数据
      if (!this.physique.wenzhenPhysique) {
        return '待分析';
      }

      // 如果是数组，使用 join
      if (Array.isArray(this.physique.wenzhenPhysique)) {
        return this.physique.wenzhenPhysique.join(", ");
      }

      // 如果是字符串，直接返回
      if (typeof this.physique.wenzhenPhysique === 'string') {
        return this.physique.wenzhenPhysique;
      }

      // 如果是对象，转换为字符串
      if (typeof this.physique.wenzhenPhysique === 'object' && this.physique.wenzhenPhysique !== null) {
        try {
          return JSON.stringify(this.physique.wenzhenPhysique);
        } catch (e) {
          return '数据格式异常';
        }
      }

      return '待分析';
    },
  },
  methods: {
    // 调用舌诊模型 (AI1)
    async callTongueModel(base64Image) {
      try {
        const params = new URLSearchParams();
        params.append('photo', base64Image);

        const response = await fetch(`${this.BaseUrl}/AI1/webUpload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',  // 关键：设置正确的Content-Type
          },
          body: params.toString()  // 关键：转换为字符串
        });

        if (!response.ok) {
          throw new Error(`舌诊API调用失败: ${response.status}`);
        }

        const data = await response.json();
        console.log('舌诊模型返回结果:', data);
        return data;
      } catch (error) {
        console.error('舌诊模型调用错误:', error);
        throw error;
      }
    },
    // 调用面诊模型 (AI2)
    async callFaceModel(base64Image) {
      try {
        const params = new URLSearchParams();
        params.append('photo', base64Image);

        const response = await fetch(`${this.BaseUrl}/AI2/webUpload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: params.toString()
        });

        if (!response.ok) {
          throw new Error(`面诊API调用失败: ${response.status}`);
        }

        const data = await response.json();
        console.log('面诊模型返回结果:', data);
        return data;
      } catch (error) {
        console.error('面诊模型调用错误:', error);
        throw error;
      }
    },
    // 调用脉诊模型 (AI3)
    async callPulseModel(pulseFile) {
      try {
        let base64Data = pulseFile;

        // 如果是File对象，需要正确转换为base64
        if (pulseFile instanceof File) {
          base64Data = await this.pulseFileToBase64(pulseFile);
        }

        if (process.env.NODE_ENV !== 'production') {
          console.log('发送脉诊数据信息:');
          console.log('- 数据长度:', base64Data.length);
          console.log('- 是否包含逗号:', base64Data.includes(','));
        }

        const params = new URLSearchParams();
        params.append('pulse', base64Data);

        const response = await fetch(`${this.BaseUrl}/AI3/webUpload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: params.toString()
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('脉诊API错误响应:', errorText);
          throw new Error(`脉诊API调用失败: ${response.status}`);
        }

        const data = await response.json();
        console.log('脉诊模型返回结果:', data);
        return data;
      } catch (error) {
        console.error('脉诊模型调用错误:', error);
        throw error;
      }
    },
    // 调用问诊模型 (AI4)
    async callWenzhenModel(grade) {
      try {
        console.log('=== 问诊API调用 ===');
        console.log('原始grade数据:', grade);

        // 确保 grade 是数组
        if (!grade || !Array.isArray(grade)) {
          throw new Error('问诊数据格式错误：不是有效的数组');
        }

        // 将数组中的每个值转换为整数，空字符串或无效值转换为0
        const cleanGrade = grade.map(val => {
          // 处理各种无效值
          if (val === null || val === undefined || val === '') {
            return 0;
          }
          // 转换为数字
          const num = Number(val);
          // 如果是NaN，返回0；否则返回整数
          return isNaN(num) ? 0 : Math.floor(num);
        });

        console.log('清洗后数据:', cleanGrade);
        console.log('清洗后数据类型:', cleanGrade.map(v => typeof v));

        const response = await fetch(`${this.BaseUrl}/AI4/webUpload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(cleanGrade)
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('问诊API错误响应:', errorText);
          throw new Error(`问诊API调用失败: ${response.status}`);
        }

        const data = await response.json();
        console.log('问诊模型返回结果:', data);
        return data;
      } catch (error) {
        console.error('问诊模型调用错误:', error);
        throw error;
      }
    },
    // 调用AI对话模型 (AI5)
    async callAIModel(content, useDeepSeek = true) {
      try {
        const url = `${this.BaseUrl}/AI5/Qwen`;
        if (process.env.NODE_ENV !== 'production') {
          console.log(`调用AI接口: ${url}`);
        }

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            content
          })
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('API响应错误:', response.status, errorText);
          const error = new Error(`API响应异常: ${response.status} ${response.statusText}`);
          error.status = response.status;
          error.responseText = errorText;
          if (response.status === 504) {
            error.message = 'AI服务响应超时，请稍后重试';
          }
          throw error;
        }

        const data = await response.json();
        console.log('AI接口响应:', data);

        if (data.status === 'success') {
          // 根据后端返回的格式：{ status: "success", reasoning: "...", answer: "..." }
          return {
            reasoning: data.reasoning || '',
            answer: data.answer || '',
            content: data.answer || data.content || ''
          };
        } else {
          throw new Error(data.message || 'API调用失败');
        }
      } catch (error) {
        console.error('AI接口调用失败:', error);
        throw error;
      }
    },
    // 文件转base64工具方法
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    // 脉诊文件转base64（保持原始格式）
    async pulseFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);  // 改用 readAsDataURL，会自动添加前缀
        reader.onload = () => {
          try {
            const dataUrl = reader.result;  // 格式: data:application/octet-stream;base64,xxxxx
            console.log('脉诊文件信息:');
            console.log('- 文件名:', file.name);
            console.log('- 文件大小:', file.size, 'bytes');
            console.log('- DataURL长度:', dataUrl.length);
            resolve(dataUrl);  // 直接返回完整的DataURL
          } catch (error) {
            console.error('转换脉诊文件失败:', error);
            reject(error);
          }
        };
        reader.onerror = error => {
          console.error('读取脉诊文件失败:', error);
          reject(error);
        };
      });
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsText(file);
      });
    },
    // 更新基本信息,当这些方法被调用时，子组件会自动接收到更新后的数据
    updateUserInfo() {
      this.userInfo = {
        // 使用展开运算符(...)将this.user对象的所有属性复制到新对象中
        ...this.user,
        pastMedicalHistory: Array.isArray(this.pastMedicalHistory) ?
          this.pastMedicalHistory.join(', ') : '无'
      };
      console.log('基本信息已更新:', this.userInfo);
    },

    // 更新问诊数据
    updateWenzhenData() {
      this.wenzhenData = {
        physique: Array.isArray(this.physique.wenzhenPhysique) ?
          this.physique.wenzhenPhysique.join(', ') : '',
        zangfu: Array.isArray(this.zangfuSelections) ?
          this.zangfuSelections.join(', ') : '',
        rhinitis: Array.isArray(this.rhinitisSelections) ?
          this.rhinitisSelections.join(', ') : '',

        analysisResult: this.physique.wenzhenPhysique || []
      };
      console.log('问诊数据已更新:', this.wenzhenData);
    },

    // 更新面诊数据
    updateFaceData(photoUrl) {
      this.mianzhenData = {
        // 传入的照片URL
        photoUrl: photoUrl,
        // 当前时间
        uploadTime: new Date().toLocaleString(),
        // 面诊分析结果
        analysisResult: this.physique.facePhysique || {}
      };
      console.log('面诊数据已更新:', this.mianzhenData);
    },

    // 更新舌诊数据
    updateTongueData(photoUrl) {
      this.shezhenData = {
        photoUrl: photoUrl,
        uploadTime: new Date().toLocaleString(),
        analysisResult: this.physique.tonguePhysique || []
      };
      console.log('舌诊数据已更新:', this.shezhenData);
    },

    // 更新闻诊数据
    updateVoiceData(audioBlob) {
      this.wenzhenAudioData = {
        // 创建临时URL用于播放音频
        audioUrl: URL.createObjectURL(audioBlob),
        // 音频时长
        duration: '待计算',
        // 记录上传时间
        uploadTime: new Date().toLocaleString(),
        // 分析结果对象
        analysisResult: {
          tone: '待分析',      // 音调
          strength: '待分析',   // 音量强度
          rhythm: '待分析',     // 节奏
          diagnosis: '待分析'   // 诊断结果
        }
      };
      console.log('闻诊数据已更新:', this.wenzhenAudioData);
    },

    // 更新脉诊数据
    updatePulseData(fileData) {
      this.maizhenData = {
        fileUrl: fileData instanceof File ? URL.createObjectURL(fileData) : fileData,
        fileName: this.getFileName(fileData),
        fileType: this.getFileType(fileData),
        uploadTime: new Date().toLocaleString(),
        analysisResult: this.physique.pulsePhysique || ['待分析']
      };
      console.log('脉诊数据已更新:', this.maizhenData);
    },

    async handleError(error, operation = '操作') {
      if (error.__handled) {
        return;
      }
      error.__handled = true;
      console.error(`${operation}失败:`, error);

      let message = `${operation}失败，请重试`;

      // 错误类型分级处理
      if (error.name === 'AbortError') {
        message = '请求超时，请检查网络';
      } else if (error.status === 504 || error.responseText?.includes('504 Gateway Time-out')) {
        message = 'AI服务响应超时，请稍后重试，或减少一次提交中的分析内容';
      } else if (error.message.includes('网络')) {
        message = '网络连接异常';
      } else if (error.message.includes('未找到')) {
        message = '资源未找到';
      } else if (error.response?.status === 401) {
        message = '身份验证失败，请重新登录';
      } else if (error.response?.status === 403) {
        message = '权限不足';
      } else if (error.response?.status >= 500) {
        message = '服务器内部错误，请稍后重试';
      }

      // 统一通知
      await Swal.fire({
        title: '出错啦',
        text: message,
        icon: 'error',
        confirmButtonText: '知道了'
      });
    },

    // origin
    async handleConsentSubmit(isAgree) {
      try {
        console.log('Consent submitted:', isAgree);
        // 1.立即更新状态（同步操作）
        this.showConsentForm = false; // 无论同意与否，先关闭同意书
        if (isAgree) {
          // 检查当前路由是否已经是目标路由
          if (this.$route.path !== '/basic') {
            await this.$router.push('/basic');// 导航到问诊页面
          }
          document.documentElement.scrollTop = 0;
          // 2.使用SweetAlert2显示操作提示
          const result = await Swal.fire({
            title: '操作提示',
            html: `<div class="justified-text">
              请您依次按照基本信息-基本信息-问诊-面诊-舌诊-脉诊的顺序完成体验。请您拍照时不要化妆，保持皮肤的自然状态。尽量选择纯色背景和自然的光照条件。录音时尽量处在安静的环境当中。（请注意，目前脉诊模块由于用户无法获取到NPY文件，所以默认上传了“平脉”脉象，只需要点击“保存”即可）。该系统处在开发和测试阶段，所有结果只供参考不作医疗指导。系统的解释权归五邑大学智能医学实验室所有。有任何疑问，请联系：j002443@wyu.edu.cn
              </div>`,
            imageUrl: 'https://itcm-wyu.oss-cn-guangzhou.aliyuncs.com/example/logo/imedLOGO.png',
            imageWidth: 200,
            imageHeight: 200,
            showCancelButton: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            allowOutsideClick: false,//禁止点击外部关闭
            backdrop: true,//显示遮罩层
            //3.弹窗关闭后的回调处理
            //添加弹窗加载状态配置
            showLoaderOnConfirm: true,//启动确认按钮加载动画
          });
          if (result.isConfirmed) {
            // 用户点击“确认”
            this.isLoading = true;
            setTimeout(() => {
              this.isLoading = false;
              this.$notify({
                title: '提示',
                message: '您已确认操作提示，可以开始基本信息流程',
                type: 'success',
                duration: 3000
              });
            }, 1000);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            // 用户点击“取消”
            this.showConsentForm = true;
            this.$notify({
              title: '提示',
              message: '您已取消操作，请仔细阅读提示内容',
              type: 'warning',
              duration: 3000
            });
          }
        } else {
          this.$notify({
            title: '提示',
            message: '您需要同意知情书才能继续使用服务',
            type: 'warning',
            duration: 3000
          });
          this.showConsentForm = true;
        }
      } catch (error) {
        await this.handleError(error, '知情同意书提交');
        this.showConsentForm = true;
        throw error;
      }
    }
    ,
    handleBasicViewSubmit(data) {
      // 确保data存在
      if (!data) {
        console.error('未接收到基本信息数据');
        return;
      }

      // 正确解构数据 - BasicView传递的是包含user和pastMedicalHistory的对象
      const { user, pastMedicalHistory } = data;

      // 确保user存在
      if (!user) {
        console.error('未接收到用户信息');
        return;
      }

      // 更新用户基本信息
      this.user = { ...user };

      // 处理既往病史格式
      let pastMedicalHistoryString = '';
      if (pastMedicalHistory && Array.isArray(pastMedicalHistory) && pastMedicalHistory.length > 0) {
        pastMedicalHistoryString = pastMedicalHistory.join(', ') || '无';
      } else {
        pastMedicalHistoryString = '无';
      }

      // 更新userInfo对象
      this.userInfo = {
        ...this.user,
        pastMedicalHistory: pastMedicalHistoryString
      };

      // 同时更新组件内部的 pastMedicalHistory 数组
      this.pastMedicalHistory = pastMedicalHistory || [];

      console.log('基本信息已接收:', {
        user: this.user,
        pastMedicalHistory: this.pastMedicalHistory,
        userInfo: this.userInfo
      });
      // 更新个人信息综合数据
      this.updateUserInfo();
    },


    handleWenzhenViewSubmit(grade, results, wuzang, rhinitis) {
      console.log("接收到的问诊数据:", {
        grade: grade,
        results: results,
        wuzang: wuzang,
        rhinitis: rhinitis
      });

      // 确保 grade 是整数数组
      let cleanGrade = grade;
      if (Array.isArray(grade)) {
        cleanGrade = grade.map(val => {
          const num = Number(val);
          return isNaN(num) ? 0 : Math.floor(num);
        });
      } else {
        cleanGrade = new Array(9).fill(0);
      }

      // 确保 results 是数字数组
      let cleanResults = results;
      if (Array.isArray(results)) {
        cleanResults = results.map(val => {
          const num = Number(val);
          return isNaN(num) ? 0 : num;
        });
      } else {
        cleanResults = [];
      }

      this.wenzhenViewpGrade = cleanGrade;
      this.wenzhenViewpGradeAnswer = cleanResults;
      this.zangfuSelections = wuzang || [];
      this.rhinitisSelections = rhinitis || [];

      console.log("清洗后的问诊评分:", this.wenzhenViewpGrade);
      console.log("清洗后的答案:", this.wenzhenViewpGradeAnswer);

      this.updateUserInfo();
      this.updateWenzhenData();
    },

    //处理面部视图的提交数据
    handleFaceViewSubmit(user_upload_photo) {
      this.faceViewPhoto = user_upload_photo;
      // 立即更新个人信息综合数据
      this.updateFaceData(user_upload_photo);
      this.mianzhenData = {
        photoUrl: user_upload_photo,
        uploadTime: new Date().toLocaleString()
      };
    },

    //处理舌部视图的提交数据
    handleTongueViewSubmit(user_upload_photo) {
      this.tongueViewPhoto = user_upload_photo;
      // 立即更新个人信息综合数据
      this.updateTongueData(user_upload_photo);
      this.shezhenData = {
        photoUrl: user_upload_photo,
        uploadTime: new Date().toLocaleString()
      };
    },

    //处理声音视图的提交数据
    handleVoiceViewSubmit(user_upload_audio) {
      this.voiceViewAudio = user_upload_audio
      // 立即更新个人信息综合数据
      this.updateVoiceData(user_upload_audio);
      this.wenzhenAudioData = {
        audioUrl: URL.createObjectURL(user_upload_audio),
        duration: '待计算',
        uploadTime: new Date().toLocaleString()
      };
    },

    //处理脉象视图的提交数据
    handlePulseViewSubmit(user_upload_pulse) {
      this.pulseViewPulse = user_upload_pulse;
      // 立即更新个人信息综合数据
      this.updatePulseData(user_upload_pulse);

    },

    getFileName(url) {
      if (!url) return '未知文件';
      if (typeof url === 'string') {
        return url.split('/').pop() || '未知文件';
      }
      return '上传的文件';
    },
    getFileType(file) {
      if (!file) return '未知';
      if (file instanceof File) {
        return file.type || file.name.split('.').pop() || '文件';
      }
      if (typeof file === 'string') {
        if (file.startsWith('data:application/octet-stream')) return 'npy';
        if (file.startsWith('data:image')) return '图片';
        if (file.startsWith('data:audio')) return '音频';
      }
      return '数据';
    },

    async submitToDiagnose() {
      // 在执行任何异步操作之前进行检查
      if (this.wenzhenViewpGradeAnswer.length === 0) {
        await Swal.fire({
          title: '警告',
          text: '基本信息未保存，请点击保存按钮后再提交。',
          icon: 'warning',
          confirmButtonText: '确定'
        });
        return;
      }

      if (!this.faceViewPhoto) {
        await Swal.fire({
          title: '警告',
          text: '脸部照片未保存，请点击保存按钮后再提交。',
          icon: 'warning',
          confirmButtonText: '确定'
        });
        return;
      }
      if (!this.tongueViewPhoto) {
        await Swal.fire({
          title: '警告',
          text: '舌部照片未保存，请点击保存按钮后再提交。',
          icon: 'warning',
          confirmButtonText: '确定'
        });
        return;
      }
      if (!this.voiceViewAudio) {
        await Swal.fire({
          title: '警告',
          text: '声音文件未保存，请点击保存按钮后再提交。',
          icon: 'warning',
          confirmButtonText: '确定'
        });
        return;
      }
      if (!this.pulseViewPulse) {
        await Swal.fire({
          title: '警告',
          text: '脉象文件未保存，请点击保存按钮后再提交。',
          icon: 'warning',
          confirmButtonText: '确定'
        });
        return;
      }

      this.isLoading = true;
      try {
        // 串行执行核心模型，AI5 只用于最终综合诊断，避免多次大模型请求导致网关超时
        console.log('开始提交问诊...');
        await this.wenzhenSubmit();
        console.log('问诊提交完成');

        console.log('开始提交面诊...');
        await this.faceSubmit();
        console.log('面诊提交完成');

        console.log('开始提交舌诊...');
        await this.tongueSubmit();
        console.log('舌诊提交完成');

        console.log('开始提交脉诊...');
        await this.pulseSubmit();
        console.log('脉诊提交完成');

        console.log('开始综合诊断...');
        await this.goToChen();
        console.log('综合诊断完成');
      } catch (error) {
        // 捕获并处理错误
        await this.handleError(error);
        throw error;
      } finally {
        // 无论成功还是失败，都关闭 isLoading
        this.isLoading = false;
      }
    },
    async basicSubmit() {
      try {
        // 验证基本信息是否完整
        if (!this.user.medicalRecordNumber || !this.user.phone ||
          !this.user.height || !this.user.weight ||
          !this.user.age || !this.user.gender) {
          throw new Error('请先完善基本信息');
        }

        const basicInfo = {
          病历号: this.user.medicalRecordNumber,
          电话: this.user.phone,
          身高: this.user.height,
          体重: this.user.weight,
          年龄: this.user.age,
          性别: this.user.gender,
          最近症状: this.user.recentSymptoms || '无',
          既往病史: this.pastMedicalHistory.join(', ') || '无'
        };

        const content = `分析以下患者基本信息，给出健康评估建议:\n${JSON.stringify(basicInfo, null, 2)}`;

        const data = await this.callAIModel(content, true);

        console.log('基本信息AI分析结果:', data);

        this.$notify({
          title: '提交成功',
          message: '基本信息已提交并分析',
          type: 'success',
          duration: 2000
        });

        return data;

      } catch (error) {
        console.error('基本信息提交失败:', error);
        await this.handleError(error, '基本信息提交');
        throw error;
      }
    },
    async wenzhenSubmit() {
      try {
        // 检查问诊数据是否存在
        if (!this.wenzhenViewpGrade || this.wenzhenViewpGrade.length === 0) {
          console.warn('问诊数据为空，使用默认值');
          // 创建9个元素的默认数组，所有值都是0
          this.wenzhenViewpGrade = new Array(9).fill(0);
        }

        // 确保所有值都是有效的整数
        const validGrade = this.wenzhenViewpGrade.map(val => {
          // 处理空字符串、null、undefined
          if (val === null || val === undefined || val === '') {
            return 0;
          }
          const num = Number(val);
          return isNaN(num) ? 0 : Math.floor(num);
        });

        // 确保数组长度至少为9
        while (validGrade.length < 9) {
          validGrade.push(0);
        }

        console.log('提交的问诊数据:', validGrade);
        console.log('提交的数据类型:', validGrade.map(v => typeof v));

        // 调用问诊模型 AI4
        const result = await this.callWenzhenModel(validGrade);

        // 处理返回结果
        if (result && result.physique) {
          this.physique.wenzhenPhysique = result.physique;
          console.log('问诊分析完成，体质结果:', result.physique);
        } else {
          this.physique.wenzhenPhysique = ['待分析'];
        }

        this.$notify({
          title: '提交成功',
          message: '问诊结果已提交并分析',
          type: 'success',
          duration: 2000
        });

        return result;
      } catch (error) {
        console.error('问诊提交失败:', error);
        await this.handleError(error, '问诊提交');
        throw error;
      }
    },

    async faceSubmit() {
      try {
        if (!this.faceViewPhoto) throw new Error('请先上传面部照片');

        let base64Image = this.faceViewPhoto;
        if (this.faceViewPhoto instanceof File) {
          base64Image = await this.fileToBase64(this.faceViewPhoto);
        }

        // 调用面诊模型 AI2
        const result = await this.callFaceModel(base64Image);

        // 处理返回结果
        if (result.filtered_results) {
          // 面诊返回格式: { "下巴": [...], "额头": [...], ... }
          this.physique.facePhysique = {
            filtered_results: result.filtered_results,
            inferenceTime: result["Inference time:"]
          };
          console.log('面诊分析完成，各部位分析:', result.filtered_results);
        } else {
          this.physique.facePhysique = { filtered_results: {}, message: result.message || '分析失败' };
        }

        this.$notify({
          title: '提交成功',
          message: '面诊结果已提交并分析',
          type: 'success',
          duration: 2000
        });

        return result;
      } catch (error) {
        console.error('面诊提交失败:', error);
        await this.handleError(error, '面诊提交');
        throw error;
      }
    },
    async tongueSubmit() {
      try {
        if (!this.tongueViewPhoto) throw new Error('请先上传舌部照片');

        let base64Image = this.tongueViewPhoto;
        if (this.tongueViewPhoto instanceof File) {
          base64Image = await this.fileToBase64(this.tongueViewPhoto);
        }

        // 调用舌诊模型 AI1
        const result = await this.callTongueModel(base64Image);

        // 处理返回结果
        if (result.filtered_results) {
          const [filteredResults, inferenceTime] = result.filtered_results;
          this.physique.tonguePhysique = filteredResults || ['待分析'];
          console.log('舌诊分析完成，耗时:', inferenceTime);
        } else {
          this.physique.tonguePhysique = [result.message || '待分析'];
        }

        this.$notify({
          title: '提交成功',
          message: '舌诊结果已提交并分析',
          type: 'success',
          duration: 2000
        });

        return result;
      } catch (error) {
        console.error('舌诊提交失败:', error);
        await this.handleError(error, '舌诊提交');
        throw error;
      }
    },

    async pulseSubmit() {
      try {
        if (!this.pulseViewPulse) throw new Error('请先上传脉象文件');

        let base64Data = this.pulseViewPulse;
        if (this.pulseViewPulse instanceof File) {
          base64Data = await this.pulseFileToBase64(this.pulseViewPulse);
        }

        // 调用脉诊模型 AI3
        const result = await this.callPulseModel(base64Data);

        // 处理返回结果
        if (result.filtered_results) {
          const [filteredResults, inferenceTime] = result.filtered_results;
          this.physique.pulsePhysique = filteredResults || ['待分析'];
          console.log('脉诊分析完成，耗时:', inferenceTime);
        } else {
          this.physique.pulsePhysique = [result.message || '待分析'];
        }

        this.$notify({
          title: '提交成功',
          message: '脉诊结果已提交并分析',
          type: 'success',
          duration: 2000
        });

        return result;
      } catch (error) {
        console.error('脉诊提交失败:', error);
        await this.handleError(error, '脉诊提交');
        throw error;
      }
    },

    async saveBasic() {
      try {
        const userInfo = JSON.stringify(this.user);
        const basicData = {
          用户信息: this.user,
          既往病史: this.pastMedicalHistory,
          最近症状: this.user.recentSymptoms || '无'
        };

        const content = `记录并分析以下患者基本信息:\n${JSON.stringify(basicData, null, 2)}`;

        const data = await this.callAIModel(content, true);

        console.log('基本信息AI记录:', data);

        this.$notify({
          title: '保存成功',
          message: '基本信息已记录并分析',
          type: 'success',
          duration: 2000
        });

        return data;

      } catch (error) {
        console.error('基本信息保存失败:', error);
        await this.handleError(error, '基本信息保存');
        throw error;
      }
    },
    // 保存舌象照片的请求可以作为一个单独的方法
    async saveTonguePhoto() {
      try {
        if (!this.tongueViewPhoto) throw new Error('请先上传舌部照片');

        let imageData = this.tongueViewPhoto;
        if (this.tongueViewPhoto instanceof File) {
          imageData = await this.fileToBase64(this.tongueViewPhoto);
        }

        const userInfo = JSON.stringify(this.user);
        const content = `记录患者舌象照片并进行分析:\n用户信息: ${userInfo}\n既往病史: ${this.pastMedicalHistory.join(', ')}\n舌象照片数据: ${imageData.substring(0, 150)}...`;

        const data = await this.callAIModel(content, true);

        console.log('舌象AI分析:', data);

        this.$notify({
          title: '保存成功',
          message: '舌诊结果已记录并分析',
          type: 'success',
          duration: 2000
        });

        return data;
      } catch (error) {
        console.error('舌诊保存失败:', error);
        await this.handleError(error, '舌诊保存');
        throw error;
      }
    },


    async saveFacePhoto() {
      try {
        if (!this.faceViewPhoto) throw new Error('请先上传面部照片');

        let imageData = this.faceViewPhoto;
        if (this.faceViewPhoto instanceof File) {
          imageData = await this.fileToBase64(this.faceViewPhoto);
        }

        const userInfo = JSON.stringify(this.user);
        const content = `记录患者面象照片并进行分析:\n用户信息: ${userInfo}\n既往病史: ${this.pastMedicalHistory.join(', ')}\n面相照片数据: ${imageData.substring(0, 150)}...`;

        const data = await this.callAIModel(content, true);

        console.log('面象AI分析:', data);

        this.$notify({
          title: '保存成功',
          message: '面诊结果已记录并分析',
          type: 'success',
          duration: 2000
        });

        return data;
      } catch (error) {
        console.error('面诊保存失败:', error);
        await this.handleError(error, '面诊保存');
        throw error;
      }
    },

    async saveWenzhen() {
      try {
        const userInfo = JSON.stringify(this.user);
        const wenzhenData = {
          用户信息: this.user,
          既往病史: this.pastMedicalHistory,
          问诊答案: this.wenzhenViewpGradeAnswer,
          体质结果: this.physique.wenzhenPhysique,
          五脏症状: this.zangfuSelections,
          鼻炎症状: this.rhinitisSelections
        };

        const content = `记录并综合分析以下问诊数据:\n${JSON.stringify(wenzhenData, null, 2)}`;

        const data = await this.callAIModel(content, true);

        console.log('问诊AI记录:', data);

        this.$notify({
          title: '保存成功',
          message: '问诊结果已记录并分析',
          type: 'success',
          duration: 2000
        });

        return data;
      } catch (error) {
        console.error('问诊保存失败:', error);
        await this.handleError(error, '问诊保存');
        throw error;
      }
    },

    async saveVoice() {
      try {
        const userInfo = JSON.stringify(this.user);
        const content = `作为中医闻诊专家，请分析患者的声音特征。\n
患者信息：${userInfo}
既往病史：${this.pastMedicalHistory.join(', ') || '无'}

请从以下方面进行中医闻诊分析：
1. 声音高低、强弱、清浊
2. 语言表达是否流畅
3. 呼吸声音特征
4. 咳嗽、嗳气等异常声音
5. 给出相应的中医诊断建议`;

        const data = await this.callAIModel(content, true);

        console.log('闻诊分析结果:', data);
        this.$notify({
          title: '保存成功',
          message: '闻诊结果已分析',
          type: 'success',
          duration: 2000
        });

        return data;
      } catch (error) {
        console.error('闻诊分析失败:', error);
        await this.handleError(error, '闻诊分析');
        throw error;
      }
    },



    async savePulse() {
      try {
        if (!this.pulseViewPulse) {
          throw new Error('脉象文件未上传');
        }

        let pulseData = '';
        if (this.pulseViewPulse instanceof File) {
          // 如果是文件对象，读取为文本或base64
          pulseData = await this.readFileAsText(this.pulseViewPulse);
        } else {
          pulseData = this.pulseViewPulse;
        }

        const userInfo = JSON.stringify(this.user);
        const pulseInfo = {
          用户信息: this.user,
          既往病史: this.pastMedicalHistory,
          脉象数据: pulseData.substring(0, 100) + '...' // 截取部分数据
        };

        const content = `作为中医脉诊专家，请分析以下脉象数据：

患者信息: ${userInfo}
既往病史: ${this.pastMedicalHistory.join(', ') || '无'}
脉象数据特征: ${pulseData.substring(0, 80)}...

请从中医脉诊角度进行专业分析：
1. 脉象类型（浮脉、沉脉、迟脉、数脉、滑脉、涩脉等）
2. 脉象特征（频率、强度、节奏、形态）
3. 对应的脏腑功能状态
4. 气血津液盛衰情况
5. 给出相应的中医诊断和治疗建议`;


        const data = await this.callAIModel(content, true);

        console.log('脉诊AI分析结果:', data);

        // 存储分析结果
        this.physique.pulsePhysique = [data.answer || data.reasoning || data.content || '待分析'];

        this.$notify({
          title: '保存成功',
          message: '脉诊数据已分析并保存',
          type: 'success',
          duration: 2000
        });

        return data;
      } catch (error) {
        // 处理错误
        console.error('Error:', error);
        await this.handleError(error, '脉诊保存');
        throw error;
      }
    },
    buildDiagnosticContent() {
      const chinColor = this.chinColor || '正常';
      const rightCheekColor = this.rightCheekColor || '正常';
      const leftCheekColor = this.leftCheekColor || '正常';
      const headColor = this.headColor || '正常';
      const noseColor = this.noseColor || '正常';
      const tonguePhysique = this.tonguePhysiqueDescription || '待分析';
      const wenzhenPhysique = this.wenzhenPhysiqueDescription || '待分析';
      const pulsePhysique = this.pulsePhysique || '待分析';
      const user = this.user;
      const pastMedicalHistory = this.pastMedicalHistory.join(", ") || "无";
      const zangfuSelections = this.zangfuSelections.join(", ") || "无";
      const rhinitisSelections = this.rhinitisSelections.join(", ") || "无";

      return `作为经验丰富的老中医，请根据以下四诊信息进行综合分析：

患者信息：
- 年龄：${user.age}，性别：${user.gender}
- 身高：${user.height}cm，体重：${user.weight}kg
- 病历号：${user.medicalRecordNumber}
- 既往病史：${pastMedicalHistory}
- 最近症状：${user.recentSymptoms || "无"}

四诊信息：
1. 面诊：
   - 下巴：${chinColor}色
   - 右脸颊：${rightCheekColor}色  
   - 左脸颊：${leftCheekColor}色
   - 额头：${headColor}色
   - 鼻子：${noseColor}色

2. 问诊：
   - 体质类型：${wenzhenPhysique}
   - 五脏症状：${zangfuSelections}
   - 鼻炎症状：${rhinitisSelections}

3. 舌诊：
   - 舌象特征：${tonguePhysique}

4. 脉诊：
   - 脉象：${pulsePhysique}

请按照以下格式给出全面的中医诊断分析：
1、面诊分析：
2、舌诊分析： 
3、问诊分析：
4、脉诊分析：
5、综合辨证：
6、体质判定：
7、调理建议：

请用专业的中医术语进行详细分析。`;
    },
    async goToChen() {
      try {
        this.isLoading = true;

        // 验证请求数据
        if (!this.validateRequestData()) {
          throw new Error('请求数据不完整');
        }

        // 构建综合诊断内容
        const diagnosticContent = this.buildDiagnosticContent();

        const data = await this.callAIModel(diagnosticContent, true);

        const diagnosticResult = data.content || data.answer || data.reasoning || '未获取到诊断结果';
        console.log('综合诊断结果:', diagnosticResult);

        // 显示诊断结果
        await this.showDiagnosticResult(diagnosticResult);

      } catch (error) {
        console.error('获取诊断结果失败:', error);
        await this.handleError(error, '获取诊断结果');
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    validateRequestData() {
      const isValid = this.user.medicalRecordNumber &&
        this.user.phone &&
        this.user.height &&
        this.user.weight &&
        this.user.age &&
        this.user.gender &&
        this.wenzhenViewpGradeAnswer.length > 0 &&
        this.faceViewPhoto &&
        this.tongueViewPhoto &&
        this.voiceViewAudio &&
        this.pulseViewPulse;

      if (!isValid) {
        console.error('数据不完整，请确保已完成所有必填项');
      }

      return isValid;
    },

    // 显示诊断结果
    async showDiagnosticResult(diagnosticContent) {
      const personalInformation = `病号：${this.user.medicalRecordNumber} &nbsp; &nbsp; &nbsp;身高：${this.user.height}cm &nbsp; &nbsp; &nbsp; 体重：${this.user.weight}kg &nbsp; &nbsp; &nbsp; 年龄：${this.user.age}岁 &nbsp; &nbsp; &nbsp; 性别：${this.user.gender}<br><br>既往病史：${this.pastMedicalHistory.join(",")}<br><br>最近症状：${this.user.recentSymptoms || '无'}<br><br>`;
      const processedText = diagnosticContent.replace(/\n/gm, "<br>");
      const finalText = personalInformation + processedText;

      await Swal.fire({
        title: '中医诊断结果',
        html: `<div class="justified-text">${finalText}</div>`,
        imageUrl: 'https://itcm-wyu.oss-cn-guangzhou.aliyuncs.com/example/logo/imedLOGO.png',
        imageWidth: 200,
        imageHeight: 200,
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: '保存为PDF',
        cancelButtonText: '取消',
        customClass: {
          popup: 'custom-swal-popup-class',
          content: 'custom-swal-content-class',
          confirmButton: 'custom-swal-confirmButton-class',
          cancelButton: 'custom-swal-cancelButton-class',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.SavePDF(diagnosticContent);
        }
      });
    },
    async SavePDF(diagnosticContent) {
      try {
        this.isLoading = true;

        // 构建符合后端 MedicalRecord 模型的数据
        const patientData = {
          medicalRecordNumber: this.user.medicalRecordNumber || '',
          height: this.user.height || '',
          weight: this.user.weight || '',
          age: this.user.age || '',
          gender: this.user.gender || '',
          pastMedicalHistory: Array.isArray(this.pastMedicalHistory) && this.pastMedicalHistory.length > 0
            ? this.pastMedicalHistory.join(', ')
            : '无',
          recentSymptoms: this.user.recentSymptoms || '无',
          text: diagnosticContent || ''
        };

        if (process.env.NODE_ENV !== 'production') {
          console.log('发送到后端的数据:', {
            medicalRecordNumber: patientData.medicalRecordNumber,
            hasText: Boolean(patientData.text)
          });
        }

        // 修正：使用正确的路由 /CreatePDF/download_pdf
        // 修改 SavePDF 方法中的 URL
        const response = await fetch(`${this.BaseUrl}/CreatPDF/download_pdf`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(patientData)
        });

        if (!response.ok) {
          // 尝试获取错误信息
          let errorMessage = `HTTP ${response.status}`;
          try {
            const errorData = await response.json();
            errorMessage = errorData.detail || errorMessage;
          } catch (e) {
            errorMessage = await response.text() || errorMessage;
          }
          throw new Error(errorMessage);
        }

        // 获取PDF文件blob
        const pdfBlob = await response.blob();

        // 创建下载链接
        const url = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `中医诊断报告_${this.user.medicalRecordNumber || '患者'}_${Date.now()}.pdf`;

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$notify({
          title: '保存成功',
          message: '诊断报告已保存为PDF文件',
          type: 'success',
          duration: 4000
        });

      } catch (error) {
        console.error('保存PDF失败:', error);
        this.$notify.error({
          title: '保存失败',
          message: 'PDF保存过程中出现错误：' + (error.message || '未知错误'),
          duration: 5000
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
}






</script>

<style lang="less">
#app {
  // 字体设置
  font-family: Avenir, Helvetica, Arial, sans-serif;
  // 字体平滑处理
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}



// nav {
//   padding: 30px;
//   background-color: #42b983;
//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }

.nav {
  background: #015128;
  padding: 15px 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  a {
    color: white;
    text-decoration: none;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 4px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }

    &.active {
      background: #42b983;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    }
  }

  // 添加提交诊断按钮样式 - 绿色（和我同意按钮一样）
  .submit-diagnose-btn {
    background-color: #4CAF50;
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: bold;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #45a049;
      transform: scale(1.02);
    }

    &:active {
      transform: scale(0.98);
    }
  }
}

.swal2-success .swal2-success-ring {
  /* 你可以在这里设置图标的背景图片、大小等 */
  background-image: url('../src/assets/wyu.png');
  //background-image: image('../src/assets/logo.png');
  background-size: contain;
  width: 100px;
  /* 根据你的图标大小调整 */
  height: 100px;
  /* 根据你的图标大小调整 */
}

.custom-swal-popup-class {
  width: 70%;
  /* 设置弹窗宽度 */
  max-width: 700px;
  /* 可选：设置最大宽度 */
}

.swal2-container-custom {
  z-index: 99999 !important;
}

.swal2-popup-custom {
  border-radius: 12px;
  max-width: 800px;
}

.swal2-title-custom {
  color: #015128;
  font-size: 1.5rem;
}

.swal2-content-custom {
  text-align: left;
  font-size: 1rem;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .swal2-popup-custom {
    max-width: 90%;
    margin: 0 10px;
  }

  .swal2-title-custom {
    font-size: 1.2rem;
  }
}

.custom-swal-content-class {
  /* 可选：调整弹窗内容区域的样式 */
}

.custom-swal-confirmButton-class {
  /* 可选：调整确认按钮的样式 */
}

.custom-swal-cancelButton-class {
  /* 可选：调整取消按钮的样式 */
}

.justified-text {

  text-align: justify;
  /* 设置文本两端对齐 */
  text-justify: inter-word;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  /* 半透明背景 */
  z-index: 1000;
  /* 确保在页面最上层 */
  display: flex;
  justify-content: center;
  /* 水平方向居中 */
  align-items: center;
  /* 垂直方向居中 */
}

.spinner-wrapper {
  display: flex;
  flex-direction: column;
  /* 垂直方向排列 */
  align-items: center;
  /* 水平方向居中 */
}

.loading-text {
  margin-top: 1rem;
  color: white;
  font-size: 2.2rem;
  font-weight: bold;
  /* 将字体设置为粗体 */
  text-align: center;
  /* 使文本居中对齐 */
}

.router-view {
  display: none;
}
</style>
